import React, { useState, useEffect } from 'react';
import { admin } from '../../services/api';
import '../../styles/AdminQueueStats.css';

function QueueStats({ onFilterFailed }) {
  const [stats, setStats] = useState({
    status_breakdown: {
      queued: 0,
      simplifying: 0,
      review_ready: 0,
      simplify_failed: 0,
      claimed: 0,
      published: 0,
    },
    total_pending_simplification: 0,
    total_review_ready: 0,
    total_failed: 0,
    total_claimed: 0,
    total_published: 0,
  });
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    try {
      const response = await admin.getQueueStats();
      setStats(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Failed to fetch queue stats:', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    
    // Auto-refresh every 30 seconds
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <div className="queue-stats-loading">Loading stats...</div>;
  }

  const { status_breakdown } = stats;

  return (
    <div className="queue-stats-widget">
      <h3>Pipeline Statistics</h3>
      <div className="stats-grid">
        <div className="stat-card stat-queued">
          <div className="stat-icon">📥</div>
          <div className="stat-content">
            <div className="stat-value">{status_breakdown.queued || 0}</div>
            <div className="stat-label">Queued</div>
          </div>
        </div>
        
        <div className="stat-card stat-processing">
          <div className="stat-icon">⚡</div>
          <div className="stat-content">
            <div className="stat-value">{status_breakdown.simplifying || 0}</div>
            <div className="stat-label">Simplifying</div>
          </div>
        </div>
        
        <div className="stat-card stat-review-ready">
          <div className="stat-icon">👀</div>
          <div className="stat-content">
            <div className="stat-value">{status_breakdown.review_ready || 0}</div>
            <div className="stat-label">Ready for Review</div>
          </div>
        </div>
        
        <div 
          className="stat-card stat-failed clickable"
          onClick={() => onFilterFailed && onFilterFailed()}
          title="Click to view failed items"
        >
          <div className="stat-icon">❌</div>
          <div className="stat-content">
            <div className="stat-value">{status_breakdown.simplify_failed || 0}</div>
            <div className="stat-label">Failed</div>
          </div>
        </div>
      </div>
      
      <div className="stats-grid" style={{ marginTop: '12px' }}>
        <div className="stat-card stat-claimed">
          <div className="stat-icon">👨‍⚕️</div>
          <div className="stat-content">
            <div className="stat-value">{status_breakdown.claimed || 0}</div>
            <div className="stat-label">In Review</div>
          </div>
        </div>
        
        <div className="stat-card stat-published">
          <div className="stat-icon">🌐</div>
          <div className="stat-content">
            <div className="stat-value">{status_breakdown.published || 0}</div>
            <div className="stat-label">Published</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QueueStats;
